// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1U0bs","title":"Info_title__3Gh7V","selects":"Info_selects__B1T-s","requiredAsterisk":"Info_requiredAsterisk__2b6Bk"};